module.exports = __webpack_public_path__ + "img/KinokoTable55.8359cbf9.jpg";